fx.ns("shared.stage", class BaseView extends fx.EventDispatcher {

    constructor(board)
    {
        super();
        
        this.board = board;
        this._positions = {};       
    }

    get numberElementsPerLine()
    {
        return Math.round(1/this.scale);
    }

    update()
    {
        this._positions = {};
    }

    get enabled()
    {
        return this._enabled;
    }

    set enabled(val)
    {
        this._enabled = val;
    }

    applyPosition(child, position, animate) 
    {   
        child.attr("scale", position.scale);

        this._positions[child.id] = position;

        child.scale = position.scale;
        child.css({ 
                    "transform" : "scale(" + position.scale + ") translate(" + position.x + "px, " + position.y + "px)",
                    "transition" : (animate ? "transform 0.25s" : "none")
                    // zoom : position.scale // TODO : use zoom for safari
                }); 

        // this should be done with a delay if animate is true
        if (typeof child.refresh == "function")
            child.refresh(position.scale);
    }

    initDelay()
    {
        this._delay = 0;
    }

    getPosition(child)
    {
        return this._positions[child.id];
    }


});